module.exports = __webpack_public_path__ + "img/card-rp-therapyevaluationquestionaire.ca0e4668.svg";